<template>
  <div class="list-search-con">
    <div class="list-mini-banner" v-show="homeBanner && homeBanner.image">
      <a :href="homeBanner.url" target="_blank" @click="gioTrackingMiniBn(homeBanner.url)">
        <img :src="homeBanner.image" />
      </a>
    </div>
    <div>
      <div class="list-search-box" :style="topSearchs.length === 0 ? 'margin-bottom: 13px' : '' ">
        <div class="list-search-btn" @click="confirmSearch">搜索</div>
        <div class="list-search-input-con">
          <input
              id="searchInput"
              class="list-search-input"
              type="text"
              name=""
              placeholder="搜索城市/国家/标签/游轮名称"
              :value="inputKeywords(keywords)"
              @focus="inputFocus = true"
              @blur.prevent="onInputBlur()"
              @input="searchInput()"
          />
          <img
              class="searchInput-clear"
              v-show="keywords && keywords.length > 0"
              @click="onClearKeyword"
              src="https://resource.rcclchina.com.cn/tui2/list/modal-close.png"
          />
        </div>
        <!-- 搜索提示框 -->
        <div id="searchInfo" class="list-search-info-con" v-show="isShowTips">
          <!-- 热门搜索 -->
          <div
              id="searchInfoNo"
              class="no-input-val-con"
              v-show="isShowTopSearch"
          >
            <div class="no-tilte">看看大家都搜什么?</div>
            <div class="no-list-con">
              <div
                  class="no-list-item"
                  v-for="(topSearch, i) in topSearchs"
                  :key="'topSearch_' + i"
                  @click.prevent="topSearchClicked(topSearch.tagName)"
              >
                {{ topSearch.tagName }}
              </div>
            </div>
          </div>
          <!-- 检索 -->
          <div
              id="searchInfoVal"
              class="input-val-info-con"
              v-show="isShowKeywordTips"
          >
            <div class="input-val-info-list-con">
              <div
                  class="input-val-info-list-item"
                  v-for="(tip, i) in keywordTips"
                  :key="'tip_' + i"
                  @click="topSearchClicked(tip)"
              >
                {{ tip }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hotTags" v-if="topSearchs.length>0">
        <span>热门搜索：<span class="tags-left" @click="toLeft()"><img src="../../../assets/tags-left-icon.png" alt=""></span></span>
        <div class="hotTags-con">
          <span class="hotTag-item" :class="{active:isLabelActive(keywords.tagType)}" v-for="(keywords, i) in topSearchs" :key="i" @click="onChangeHotTag(keywords.tagType)">
           {{ keywords.tagType }}
          </span>
        </div>
        <span class="tags-right" @click="toRight"><img src="../../../assets/tags-right-icon.png" alt=""></span>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import {gioAdsTracking, gioTracking} from "@/utilities/tools";
export default {
  name: "CruiseSearchInput",
  props: {
    onKeywordConfirmHandler: {
      type: Function,
    },
    topSearchs: {
      type: Array,
      default() {
        return [];
      },
    },
    initKeyword: {
      type: Array,
    },
    hotTags:{
      type: Array,
      default() {
        return [

        ];
      },
    }
  },
  data() {
    return {
      inputFocus: false,
      keywords: "",
      keywordTips: [],
      hotTagIdx:-1
    };
  },
  searchTimeout: null,
  methods: {
    topSearchClicked(topSearch) {
      if (topSearch != this.keywords) {
        this.keywords = topSearch;
        this.confirmSearch();
      }
    },
    onClearKeyword() {
      if (this.keywords && this.keywords.length > 0) {
        this.keywords = "";
        this.confirmSearch();
      }
    },
    confirmSearch() {
      this.keywordTips = [];
      this.inputFocus = false;
      this.onKeywordConfirmHandler(this.keywords);
    },
    onInputBlur() {
      setTimeout(() => {
        this.inputFocus = false;
      }, 200);
    },
    searchInput() {
      if (this.keywords && this.keywords.length > 0) {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
        this.searchTimeout = setTimeout(() => {
          this.searchKeywordTips();
        }, 1200);
      }
    },
    async searchKeywordTips() {
      const { data } = await api.cruise.searchKeywordTips({
        keywords: this.keywords,
      });
      if (data) {
        this.keywordTips = data;
      } else {
        this.keywordTips = [];
      }
    },
		gioTrackingMiniBn (link) {
      gioTracking('track', 'evt_ButtonClicked',{
        'btnType': `CruiseSearchBannerTopLeft`
      })
			gioAdsTracking({
				'adsType': 'miniBn',
				'desUrl': link
			})
		},
    onChangeHotTag(keywords){
      const index = this.keywords.findIndex(item => item.code === keywords);
      if (index !== -1) {
        // 如果找到了，删除它
        this.keywords.splice(index, 1);
      } else {
        // 如果没找到，添加新的元素
        this.keywords.push({ name: keywords, key: 'keywords', code: keywords });
      }
      this.confirmSearch();
    },
    isLabelActive(name){
      // 判断是否选中
      return this.keywords.filter((r) => r.code == name).length > 0
    },
    inputKeywords(keywords){
      if(keywords && keywords.length > 0){
        return keywords.map(r => r.code).join(',')
      }
    },
    toLeft(){
      let hotTagItme = document.querySelector('.hotTags-con');
      if(hotTagItme.scrollLeft > 0){
        hotTagItme.scrollLeft -= 100;
      }
    },
    toRight(){
      let hotTagItme = document.querySelector('.hotTags-con');
      if(hotTagItme.scrollLeft < hotTagItme.scrollWidth - hotTagItme.clientWidth){
        hotTagItme.scrollLeft += 100;
      }
    },
  },
  computed: {
    isShowTips() {
      return (
        this.inputFocus && (this.isShowTopSearch || this.isShowKeywordTips)
      );
    },
    isShowTopSearch() {
      return this.keywords.length == 0 && this.topSearchs.length > 0;
    },
    isShowKeywordTips() {
      return this.keywords.length > 0 && this.keywordTips.length > 0;
    },
    homeBanner() {
      let pageData = this.$store.state.cruise.cruiseSearchPage;
      if (!pageData) {
        return {};
      }
      return pageData.homeBanner;
    },
  },
  watch: {
    initKeyword(newOne) {
      console.log(newOne)
      this.keywords = newOne;
    },
  },
};
</script>

<style lang="less" scoped>
.list-search-con {
  width: 100%;
  //height: 80px;
  display: flex;
  justify-content: space-between;
  .list-mini-banner {
    //float: left;
    margin-top: 13px;
    & img {
      width: 473px;
      height: 64px;
    }
  }
  .list-search-box {
    position: relative;
    //float: right;
    margin-top: 13px;
    flex-direction: row-reverse;
    display: flex;
    .list-search-btn {
      //float: right;
      width: 106px;
      height: 40px;
      line-height: 40px;
      background-color: #0073bb;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
    }
    .list-search-input-con {
      height: 40px;
      background-color: #fff;
      border: 1px solid #d3dadd;
      padding: 0 14px;
      float: right;
      cursor: pointer;
      position: relative;
      input {
        float: left;
        margin: 0 5px;
        width: 38px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        background: #fff;
        border: 1px solid #ebebeb;
        outline: none;
        color: #bdbdbd;
        font-size: 14px;
      }
      .list-search-input {
        border: none;
        width: 570px;
        text-align: left;
        color: #5a5a5a;
        &::placeholder {
          color: #a6aeb1;
          font-style: normal;
        }
      }
      .searchInput-clear {
        position: absolute;
        width: 18px;
        right: 5px;
        top: 9px;
      }
    }
    .list-search-con::after {
      content: "";
      clear: both;
    }
  }
  .hotTags{
    padding-top: 6px;
    display: flex;
    position: relative;
    bottom: 3px;
    white-space: nowrap;
    & span{
      font-size: 14px;
      color: #7c878a;
      cursor: pointer;
    }
    & .tags-left{
      padding: 0 8px;
    }
    & .tags-right{
      position: absolute;
      right: 0;
      bottom: 0;
      padding: 0 8px;
    }
    & .hotTags-con{
      padding: 0 4px;
      width: 600px;
      white-space: nowrap;
      overflow: hidden;
      overflow-x: scroll;
    }
    & .hotTags-con::-webkit-scrollbar {
      display: none;
      height: 0;
      }
      & .hotTag-item{
      display: inline-block;
      //width: 95px;
      height: 20px;
      padding: 0 11px;
      background-color: #def0fe;
      text-align: center;
      line-height: 20px;
      color: #0064bc;
      border-radius: 9.5px;
      margin-right: 11px;
      font-size: 11px;
      cursor: pointer;
    }
    & .hotTag-item.active{
      background-color: #0064bc;
      color: #fff!important;
    }
  }
  .list-search-info-con {
    width: 100%;
    position: absolute;
    top: 42px;
    left: 0;
    background-color: #ffffff;
    box-shadow: 0px 0px 16px 0px rgba(46, 65, 80, 0.17);
    border-radius: 3px;
    border: solid 1px #e5e9eb;
    z-index: 2;
    .no-input-val-con {
      padding: 20px 8px;
      .no-tilte {
        margin-left: 7px;
        font-size: 14px;
        color: #282b2c;
        margin-bottom: 8px;
      }
      .no-list-con {
        color: #747d80;
        float: left;
        padding-bottom: 8px;
        .no-list-item {
          margin: 2px 7px;
          float: left;
          cursor: pointer;
        }
      }
    }
    .input-val-info-list-item {
      width: 100%;
      height: 31px;
      line-height: 31px;
      padding: 0 15px;
      cursor: pointer;
    }
    .input-val-info-list-item:hover {
      background-color: #e5f4ff;
    }
  }
}
</style>
